import { Injectable } from '@angular/core';
import { CoalService } from 'app/services/coal.service';
import { BehaviorSubject } from 'rxjs';
import { EstatusFolios } from 'app/shared/enum.shared';

@Injectable({
    providedIn: 'root' // Esto asegura que el servicio esté disponible globalmente
})
export class EmpresaService {
    resumen = {
        folios: 0,
        usados: 0,
        vencidos: 0,
        disponibles: 0
    }
    idEmpresa: any;

    constructor(private coalService: CoalService){

    }

    private empresaSeleccionadaSource = new BehaviorSubject<any>(null);
    empresaSeleccionada$ = this.empresaSeleccionadaSource.asObservable();

    // Observables para manejar las facturas restantes
    private facturasRestantesSource = new BehaviorSubject<number>(0); // Valor inicial
    facturasRestantes$ = this.facturasRestantesSource.asObservable();

    /**
     * Método para seleccionar la empresa
     * @param empresa Datos de la empresa seleccionada
     */
    seleccionarEmpresa(empresa: any) {
        console.log('La empresa seleccionada ha cambiado', empresa);
        this.idEmpresa = empresa.id;
        this.empresaSeleccionadaSource.next(empresa);
        this.getFolios();
    }

    /**
     * Método para actualizar el número de facturas restantes
     * @param facturas Número de facturas restantes
     */
    setFacturasRestantes(facturas: number) {
        console.log('El número de facturas restantes ha cambiado a:', facturas);
        this.facturasRestantesSource.next(facturas);
    }

    /**
     * Método para obtener el valor actual de facturas restantes
     * @returns Número de facturas restantes
     */
    getFacturasRestantes(): number {
        return this.facturasRestantesSource.value;
    }

    getFolios() {
        this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_paquetes.ope_empresa_paquete_hs.cat_paquete_estatus`)
        .subscribe((res: any) => {
          const data = res.data[0]?.attributes?.ope_empresa_paquetes?.data?.sort((a,b) => b.id - a.id);
          this.calculateFolios(data);
        }, (error: any) => {
          console.log(error);
          
        });
    }

    calculateFolios(data) {
        let folios = data;
        let activeFolios = folios.filter(function(paquete) {
            return this.indexOf(paquete?.attributes?.ope_empresa_paquete_hs?.data[0]?.attributes?.cat_paquete_estatus?.data?.id) < 0;
          }, [EstatusFolios.Cancelado, EstatusFolios.SolicitudEnviada]);
        let total = activeFolios.map(item => item.attributes?.folios).reduce((a,b) => a+b, 0);
    
        this.resumen.folios = total;
        this.resumen.vencidos = 0;
        this.resumen.usados = activeFolios.map(item => item.attributes?.usado).reduce((a,b) => a+b,0);
        this.resumen.disponibles = total - this.resumen.usados;

        console.log('calculateFolios', this.resumen);
        this.setFacturasRestantes(this.resumen.disponibles);
    }
}